enum editorTypeDict {
  MATTER = 'matter', // 事项结论
  MEETING = 'meeting', // 纪要草稿
  DETAIL = 'detail', // 背景信息 -- 废弃
  DIARY = 'diary', // 个人笔记
}

enum embedType {
  MATTER = 'matter',
  PEOPLE = 'people',
}

const placeholderDict: { [k in EditorType]: string } = {
  [editorTypeDict.MATTER]: '输入结论',
  [editorTypeDict.MEETING]: '添加纪要描述...',
  [editorTypeDict.DETAIL]: '背景信息/说明',
  [editorTypeDict.DIARY]: '输入内容',
}

export { editorTypeDict, placeholderDict, embedType }
